import { Box } from '@mui/material'
import ImpersonateButton from './impersonateButton'
import { PersonificationRowType } from './tableColumns'

interface RowActionsProps {
  row: {
    original: PersonificationRowType
  }
}

const RowActions = ({ row }: RowActionsProps) => {
  return (
    <Box sx={{ pr: '10px', display: 'flex', justifyContent: 'flex-end' }}>
      <ImpersonateButton auth0Id={row.original.auth0_id} />
    </Box>
  )
}

export default RowActions
